var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-top menucontrol-scroll"},[_c('Banner'),_c('ReviewTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }